import { ValidationError } from 'yup';

/**
 * Преобразует агрегированную ошибку Yup (`abortEarly: false`) в объект «поле → сообщение».
 *
 * @param {ValidationError} errors — корневая ошибка валидации Yup
 * @returns {Record<string, string>} первое сообщение по каждому пути
 */
export function transformYupErrorsIntoObject(errors: ValidationError): Record<string, string> {
  const validationErrors: Record<string, string> = {};

  errors.inner.forEach((error: ValidationError) => {
    if (error.path !== undefined && error.errors.length > 0) {
      const first = error.errors[0];
      if (first !== undefined) {
        validationErrors[error.path] = first;
      }
    }
  });

  return validationErrors;
}
